import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { EmailValidator } from '../../validators/email';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { ChangePasswordPage } from '../change-password/change-password';
import { CropImagePage } from '../crop-image/crop-image';
import { BatchPage } from '../batch/batch';
import { ComAndSuggListPage } from '../com-and-sugg-list/com-and-sugg-list';

@IonicPage()
@Component({
  selector: 'page-profileview',
  templateUrl: 'profileview.html',
})
export class ProfileviewPage {
  public max = new Date();
  myForm: FormGroup;
  loading: Loading;
  file: any;
  img: string;
  isAdmin: boolean;

  constructor(public navCtrl: NavController, dateTimeAdapter: DateTimeAdapter<any>, public navParams: NavParams, public af: AngularFirestore, public afa: AngularFireAuth, public formBuilder: FormBuilder, public loadingCtrl: LoadingController, public toastCtrl: ToastController, public modalCtrl: ModalController) {
    dateTimeAdapter.setLocale('es-ES'); // change locale to spanish 
    this.myForm = this.formBuilder.group({
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      sex: ['', Validators.required],
      email2: ['', [Validators.required, EmailValidator.isValid]],
      dob: [''],
      company: [''],
      ocupation: [''],
      phone: ['']
    });
    this.afa.auth.onAuthStateChanged(user => {
      if (user && user.uid) {
        this.af.doc('Users/' + user.uid).snapshotChanges().subscribe(document => {
          if (document.payload.exists) {
            const data = document.payload.data();
            this.isAdmin = data && data.type && data.type == 1 ? true : false;
            //console.log(this.isAdmin);
            this.img = data && data.profile && data.profile.downloadURL ? data.profile.downloadURL : '';
            this.myForm.setValue({
              "name": data && data.name ? data.name : '',
              "lastName": data && data.lastName ? data.lastName : '',
              "sex": data && data.sex ? data.sex : '',
              "email2": data && data.email2 ? data.email2 : '',
              "dob": data && data.dob ? moment(data.dob).format('YYYY-MM-DD') : '',
              "company": data && data.company ? data.company : '',
              "ocupation": data && data.ocupation ? data.ocupation : '',
              "phone": data && data.phone ? data.phone : ''
            });

          }
        });
      }
    });
  }

  ionViewDidLoad() { }

  onSubmit() {
    this.presentLoadingCustom();
    if (this.myForm.value.dob) {
      this.myForm.value.dob = moment(this.myForm.value.dob).format("YYYY-MM-DD");
    }


    let update = {
      name: this.myForm.value.name,
      lastName: this.myForm.value.lastName,
      sex: this.myForm.value.sex,
      email2: this.myForm.value.email2,
      dob: this.myForm.value.dob,
      company: this.myForm.value.company,
      ocupation: this.myForm.value.ocupation,
      phone: this.myForm.value.phone,
      uppercaseName: String(this.myForm.value.lastName + " " + this.myForm.value.name).toLocaleUpperCase(),
    }


    this.af.doc("Users/" + this.afa.auth.currentUser.uid).update(update).then(() => {
      this.loading.dismiss();
      this.presentToast("Perfil actualizado correctamente!");
      ////console.log("Correcto");
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast("Ha ocurrido un error!");
      ////console.log(error);
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  cancel() {
    this.navCtrl.pop();
  }

  changePassword() {
    let modal = this.modalCtrl.create(ChangePasswordPage);
    modal.present();
  }

  changeProfileImage() {
    let modal = this.modalCtrl.create(CropImagePage);
    modal.present();
  }

  batch(type: string) {
    let modal = this.modalCtrl.create(BatchPage, { "type": type });
    modal.present();
  }

  comAndSuggList() {
    let modal = this.modalCtrl.create(ComAndSuggListPage);
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/profileview/profileview.ts